import { inject } from '@angular/core';
import { IsProjectLockedGuardService } from './is-project-locked-guard.service';
import { ActivatedRouteSnapshot } from '@angular/router';

export const isProjectLockedGuard = (activatedRoute: ActivatedRouteSnapshot) => {
    const isProjectLockedGuardService = inject(IsProjectLockedGuardService);

    return isProjectLockedGuardService.canActivate(activatedRoute);
};
